import { convertToTwoDecimelNumber, getCookie, handleLogOut, simulateAsyncOperation, throttle } from 'mmbclient/Common/CommonFunctions';
import { checkSession, getAllClients } from 'mmbclient/Common/CommonService';
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, CREDIT_PICKUP_REQUEST_PATH, DASHBOARD_REPORT, EP, GLOBAL_CONTEXT, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_THROTTLE_TIME, PAGE_LOADING_TIME, US, USER_TYPE_COOKIE_NAME } from 'mmbclient/Common/CommonVariable';
import React, { useContext, useEffect, useState } from 'react'
import './Dashboard.css'
import CircularSpinner from 'mmbclient/Components/CircularSpinner';
import BarChart from 'mmbclient/Components/BarChart';
import PieChart from 'mmbclient/Components/PieChart';

export function Dashboard() {

    const store = useContext(GLOBAL_CONTEXT);

    const [loading, setLoading] = useState(false);

    const Select = "Select Client...";

    const [dates, setDates] = useState({ fromDate: '', toDate: '', client: Select });

    const [clientOption, setClientOption] = useState([]);

    const allFynclYear = ['2024-2025', '2023-2024', '2022-2023', '2021-2022', '2020-2021'];
    const [paymentFilter, setPaymentFilter] = useState({ fynclYr: allFynclYear[0], client: Select, fromDate: '', toDate: '' });
    const [paymentBarChartData, setPaymentBarChartData] = useState({ barChartLabel: [], barChartData1: [], barChartData2: [], pieChartLabel: [], pieChartData: [] });

    const defaultData = [
        { count: 0, name: "BOOKING", color: 'success' },
        { count: 0, name: "DELIVERED", color: 'primary' },
        { count: 0, name: "PENDING", color: 'danger', details: "" },
        { count: 0, name: "EXCEPTION", color: 'warning', details: "" },
    ];

    const [shipmentData, setShipmentData] = useState(defaultData);

    const today = new Date();
    const toDate = today.toISOString().split("T")[0]; // Format to YYYY-MM-DD
    const fromDate = new Date(today);
    fromDate.setDate(today.getDate() - 14); // Subtract 14 days
    const formattedFromDate = fromDate.toISOString().split("T")[0]; // Format to YYYY-MM-DD
    fromDate.setDate(today.getDate() - 60); // Subtract 14 days
    const formattedFromDateForPayment = fromDate.toISOString().split("T")[0]; // Format to YYYY-MM-DD

    // Set today's date and 14 days before today's date
    useEffect(() => {
        // Fetch data from server
        const fetchData = async () => {

            setLoading(true);
            try {
                getCookie(USER_TYPE_COOKIE_NAME) === US
                    ?
                    (
                        await Promise.all([
                            setDates({ fromDate: formattedFromDate, toDate }),
                            setPaymentFilter({ fromDate: formattedFromDateForPayment, toDate }),
                            fetchShipmentDetails(store, formattedFromDate, toDate, false),
                            fetchPaymentDetails(store, formattedFromDateForPayment, toDate, false),
                            simulateAsyncOperation(PAGE_LOADING_TIME),
                        ])
                    )
                    :
                    (
                        await Promise.all([
                            setDates({ fromDate: formattedFromDate, toDate, client: Select }),
                            setPaymentFilter({ fromDate: formattedFromDateForPayment, toDate }),
                            loadAllClients(store),
                            simulateAsyncOperation(PAGE_LOADING_TIME),
                        ])
                    );
                // getCookie(USER_TYPE_COOKIE_NAME) === US ? getCookie(LOGIN_COOKIE_NAME).split(LOGIN_COOKIE_NAME_SPLITBY)[1] : ''
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    async function loadAllClients(store) {

        const response = await getAllClients(store);
        let lst_Client = [];
        lst_Client.push(Select);
        if (response.length > 0) {
            let i;
            for (i of response) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
        }
        setClientOption(lst_Client);
    }

    const getShipmentDetails = async () => {
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) && dates.client === Select) {
            alert("Please select client");
            return;
        }

        if (checkDateGap(dates.fromDate, dates.toDate) === false) {
            return;
        }

        setLoading(true); // Set loading to true immediately

        // Create a promise to fetch shipment details
        const fetchPromise = await fetchShipmentDetails(store, dates.fromDate, dates.toDate, true);

        // Set a timeout to turn off loading after 2 seconds
        const timeoutPromise = new Promise(resolve => {
            setTimeout(() => {
                resolve(false); // Return false to indicate we should stop loading
            }, 2000);
        });

        // Wait for both the fetch and the timeout to complete
        await Promise.race([fetchPromise, timeoutPromise]);

        // Regardless of which promise resolves first, set loading to false
        setLoading(false);
    };


    async function fetchShipmentDetails(store, fromDate, toDate, alertFlag) {
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        if (cookie === '') {
            handleLogOut(store);
        } else {
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
            const userKey = c[0];

            const userId = getCookie(USER_TYPE_COOKIE_NAME);

            let clientCode;
            if (US === userId) {
                clientCode = c[1];
            } else if (AD === userId || EP === userId) {
                clientCode = dates.client.split("|")[1].trim();
            }

            if (c.length === 4) {
                const query = { "userKey": userKey, fromDate: fromDate, toDate: toDate, bean: "Data", userId: userId, userType: getCookie(APP_TYPE_COOKIE_NAME), clientCode: clientCode };
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query)
                    })
                };
                const res = await fetch(API_PATH + DASHBOARD_REPORT + "getdelstatus", requestOptions);
                const data = await res.json();
                const response = JSON.parse(data)[0].Data;

                const result = [];
                let bookingCount = 0, deliveredCount = 0, pendingCount = 0, exceptionCount = 0;
                let pendingDetails = "", exceptionDetails = "";

                const pendingStatus = ['RTO', 'OUT', 'INT', 'INSC', 'MNF'];

                if ("Result Not Found" !== response
                    && Array.isArray(response)
                    && response.length > 0) {
                    for (const item of response) {
                        const delStatus = item.delivery_status;
                        const total = item.total;
                        if ('BOK' == delStatus) {
                            bookingCount = total;
                        } else if ('DEL' == delStatus) {
                            deliveredCount = total;
                        } else if (pendingStatus.includes(delStatus)) {
                            pendingCount += total;
                            pendingDetails += item.delivery_status + " : " + total + "   |   ";
                        } else {
                            exceptionCount += total;
                            exceptionDetails += item.delivery_status + " : " + total + "   |   ";
                        }
                    }

                    const booking = { count: bookingCount, name: "BOOKING", color: 'success' };
                    const delivered = { count: deliveredCount, name: "DELIVERED", color: 'primary' };
                    const pending = { count: pendingCount, name: "PENDING", color: 'danger', details: pendingDetails.slice(0, -7) };
                    const exception = { count: exceptionCount, name: "EXCEPTION", color: 'warning', details: exceptionDetails.slice(0, -7) };
                    result.push(booking);
                    result.push(delivered);
                    result.push(pending);
                    result.push(exception);
                    setShipmentData(result);
                } else {
                    setShipmentData(defaultData);
                    if (alertFlag) {
                        // alert("No data found");
                    }
                }


            } else {
                handleLogOut(store);
            }
        }
    }

    function checkDateGap(fromDateStr, toDateStr) {
        const fromDate = new Date(fromDateStr);
        const toDate = new Date(toDateStr);

        // Check if the dates are valid
        if (isNaN(fromDate)) {
            alert("Please enter valid Start date.");
            return false; // Indicate that the check failed
        }
        if (isNaN(toDate)) {
            alert("Please enter valid End date.");
            return false; // Indicate that the check failed
        }

        // Calculate the difference in time
        const timeDiff = toDate - fromDate; // Difference in milliseconds

        // Convert time difference to years
        const yearDiff = timeDiff / (1000 * 60 * 60 * 24 * 365.25); // Using 365.25 to account for leap years

        if (yearDiff > 1) {
            alert("The gap between the two dates should not be more than 1 year.");
            return false; // Indicate that the check failed
        }

        return true; // Indicate that the check passed
    }

    const getPaymentDetails = async () => {
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) && paymentFilter.client === Select) {
            alert("Please select client");
            return;
        }

        if (checkDateGap(paymentFilter.fromDate, paymentFilter.toDate) === false) {
            return;
        }

        setLoading(true); // Set loading to true immediately

        // Create a promise to fetch shipment details
        const fetchPromise = await fetchPaymentDetails(store, paymentFilter.fromDate, paymentFilter.toDate, true);

        // Set a timeout to turn off loading after 2 seconds
        const timeoutPromise = new Promise(resolve => {
            setTimeout(() => {
                resolve(false); // Return false to indicate we should stop loading
            }, 2000);
        });

        // Wait for both the fetch and the timeout to complete
        await Promise.race([fetchPromise, timeoutPromise]);

        // Regardless of which promise resolves first, set loading to false
        setLoading(false);
    };

    async function fetchPaymentDetails(store, fromDate, toDate, alertFlag) {
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        if (cookie === '') {
            handleLogOut(store);
        } else {

            // const spltArr = financialYear.split("-");
            // const spltArr = fynclYear.split("-");
            // const fromYear = spltArr[0].trim();
            // const toYear = spltArr[1].trim();

            const Data = "Data";
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const userId = getCookie(USER_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
            const userKey = c[0];

            let clientCode;
            if (US === userId) {
                clientCode = c[1];
            } else if (AD === userId || EP === userId) {
                clientCode = paymentFilter.client.split("|")[1].trim();
            }
            if (c.length === 4) {
                const query = { "userKey": userKey, "userType": cookieUserType, "bean": Data, "clientCode": clientCode, "fromDate": fromDate, "toDate": toDate, "userId": userId };
                // const query = { "userKey": userKey, "userType": cookieUserType, "bean": Data, "clientCode": clientCode, "fromYear": fromYear, "toYear": toYear, "userId": userId };
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query)
                    })
                };

                const path = API_PATH + DASHBOARD_REPORT + "getpiechartdata";

                const res = await fetch(path, requestOptions);
                const data = await res.json();
                const response = JSON.parse(data)[0].Data;
                let totalAmt = 0, paidAmt = 0, balAmt = 0;
                if (response.length > 0 && response !== "Result Not Found") {
                    if (response[0].total === undefined) {
                        totalAmt = 0;
                    } else {
                        totalAmt = response[0].total;
                    }
                    if (response[0].paid === undefined) {
                        paidAmt = 0;
                    } else {
                        paidAmt = response[0].paid;
                    }
                    if (response[0].balance === undefined) {
                        balAmt = 0;
                    } else {
                        balAmt = response[0].balance;
                    }
                    // console.log(response);
                } else {
                    console.log(response);
                }


                const path2 = API_PATH + DASHBOARD_REPORT + "getbarchartdata";
                const res2 = await fetch(path2, requestOptions);
                const data2 = await res2.json();
                const response2 = JSON.parse(data2)[0].Data;

                const barData = [], barLabel = [], barDataPayment = [];
                if (response2.length > 0) {
                    for (let i = 0; i < response2.length; i++) {
                        barLabel.push(response2[i].invoice_no);
                        barData.push(convertToTwoDecimelNumber(response2[i].grand_total));
                        barDataPayment.push(convertToTwoDecimelNumber(response2[i].paid));
                    }
                }

                let pieLabel = [], pieData = [];
                if (totalAmt !== 0) {
                    pieLabel = ['Total:' + convertToTwoDecimelNumber(totalAmt), 'Paid', 'Balance'];
                    pieData = ['', convertToTwoDecimelNumber(paidAmt), convertToTwoDecimelNumber(balAmt)];
                }
                setPaymentBarChartData({
                    ...paymentBarChartData,
                    'pieChartLabel': pieLabel,
                    'pieChartData': pieData,
                    'barChartLabel': barLabel,
                    'barChartData1': barData,
                    'barChartData2': barDataPayment,
                });
            } else {
                handleLogOut(store);
            }
        }
    }

    const loggerFunc = () => {
        checkSession(store);
    }

    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);


    return (
        <>
            <div onMouseOver={betterLoggerFunction}>
                {loading && <CircularSpinner />}
                <h4 className="text-center mt-3 fw-bolder">Dashboard</h4> {/* Centered header */}
                <div className="container my-3">
                    <div className="border p-4 rounded bg-light"> {/* Added boundary here */}
                        <div className="row mb-4">
                            <div className="col-md-2 mb-2 mb-md-0">
                                <h5>Shipment Details</h5>
                            </div>
                            {
                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ?
                                    <>
                                        <div className="col-md-4 mb-2 mb-md-0">
                                            {/* <label className="form-label">Client</label> */}
                                            <select
                                                className="form-select"
                                                value={dates.client}
                                                onChange={(e) => setDates({ ...dates, client: e.target.value })}
                                            >
                                                {clientOption.map((option, index) => (
                                                    <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </> : null
                            }
                            <div className="col-md-2 mb-2 mb-md-0">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={dates.fromDate}
                                    onChange={(e) => setDates({ ...dates, fromDate: e.target.value })}
                                />
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={dates.toDate}
                                    onChange={(e) => setDates({ ...dates, toDate: e.target.value })}
                                />
                            </div>
                            <div className="col-md-2">
                                <button onClick={getShipmentDetails} className="btn btn-primary w-100">
                                    Search
                                </button>
                            </div>
                        </div>

                        <div className="row">
                            {shipmentData.map((item, index) => (
                                <div className="col-md-3 mb-3" key={index}>
                                    <div className={`card text-white bg-${item.color} bg-light card-custom-height`}>
                                        <div className={`card-body bg-${item.color}`}>
                                            <div className="card-title display-6 fw-bold text-white">{item.count}</div>  {/* For count */}
                                            <div className="card-title h5 fw-bold text-white">{item.name}</div>  {/* For name */}
                                            {item.details && <p className="text-white">{item.details}</p>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


                <div className="container my-3">
                    <div className="border p-4 rounded bg-light"> {/* Added boundary here */}
                        <div className="row mb-4">
                            <div className="col-md-2 mb-2 mb-md-0">
                                <h5>Payment Details</h5>
                            </div>
                            {
                                (getCookie(USER_TYPE_COOKIE_NAME) === AD  || getCookie(USER_TYPE_COOKIE_NAME) === EP) ?
                                    <>
                                        <div className="col-md-4 mb-2 mb-md-0">
                                            {/* <label className="form-label">Client</label> */}
                                            <select
                                                className="form-select"
                                                value={paymentFilter.client}
                                                onChange={(e) => setPaymentFilter({ ...paymentFilter, client: e.target.value })}
                                            >
                                                {clientOption.map((option, index) => (
                                                    <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </> : null
                            }
                            <div className="col-md-2 mb-2 mb-md-0">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={paymentFilter.fromDate}
                                    onChange={(e) => setPaymentFilter({ ...paymentFilter, fromDate: e.target.value })}
                                />
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={paymentFilter.toDate}
                                    onChange={(e) => setPaymentFilter({ ...paymentFilter, toDate: e.target.value })}
                                />
                            </div>
                            {/* <div className="col-md-2 mb-2 mb-md-0">
                                <select
                                    className="form-select"
                                    value={paymentFilter.fynclYr}
                                    onChange={(e) => setPaymentFilter({ ...paymentFilter, fynclYr: e.target.value })}
                                >
                                    {allFynclYear.map((option, index) => (
                                        <option key={index} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div> */}
                            <div className="col-md-2">
                                <button onClick={getPaymentDetails} className="btn btn-primary w-100">
                                    Search
                                </button>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-8 mb-2 mb-md-0">
                                <BarChart
                                    labels={paymentBarChartData.barChartLabel}
                                    // labels={['April', 'May', 'January', 'February', 'March']}
                                    data1={paymentBarChartData.barChartData1}
                                    // data1={[12, 19, 3, 5]}
                                    chartLabel1="Invoice"
                                    data2={paymentBarChartData.barChartData2}
                                    // data2={[12, 19, 3, 5]}
                                    chartLabel2="Payment"
                                    chartHeight={300}
                                />
                            </div>
                            <div className="col-md-4 mb-2 mb-md-0">
                                <PieChart
                                    labels={paymentBarChartData.pieChartLabel}
                                    // labels={['Red', 'Blue', 'Yellow', 'Green']}
                                    data={paymentBarChartData.pieChartData}
                                    // data={[300, 50, 100, 150]}
                                    chartLabel=""
                                    chartHeight={300}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}